import { Checkbox } from '@eliadmin/core/src/components/ui/checkbox';
import { Label } from '@eliadmin/core/src/components/ui/label';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { compareNames } from '@/lib/compare-names';

export type GenericType = {
  type: 'manufacturer' | 'status' | 'availability' | 'supplier';
  type2: 'manufacturers' | 'statuses' | 'availabilities' | 'suppliers';
};

export function AttributeGeneric({ type, type2 }: GenericType) {
  const { t } = useTranslations();
  const data = useCategoryStore(state => state.category[type2]);
  const filter = useCategoryStore(state => state.filter[type2]);
  const setFilter = useCategoryStore(state => state.setFilter);

  // Manufacturers come in import order (HEWLETT PACKARD, HP Inc., ASUS…), so they read A–Z.
  const sortedValues = [...(data ?? [])].sort(
    type === 'manufacturer' ? compareNames : (a, b) => (a.position ?? 0) - (b.position ?? 0),
  );

  return (
    <div className={cn('flex flex-col gap-3', 'ea-attribute-generic')}>
      {data?.length ? (
        sortedValues.map(value => (
          <div
            key={`attribute-${type}-value-${value.id}`}
            className={cn(
              'mr-2 flex flex-row items-center space-x-2',
              'ea-attribute-generic__input-wrapper',
            )}
          >
            <Checkbox
              id={`attribute-${type}-value-${value.id}`}
              name={`attribute-${type}-value-${value.id}`}
              className={cn('', 'ea-attribute-generic__input')}
              checked={filter.includes(value.id)}
              onCheckedChange={() => setFilter({ [type]: value.id })}
            />
            <Label
              htmlFor={`attribute-${type}-value-${value.id}`}
              className={cn('', 'ea-attribute-generic__label')}
            >
              {value.name}
            </Label>
            {/* <label htmlFor={`attribute-${type}-value-${value.id}`}>{value.name}</label> */}
          </div>
        ))
      ) : (
        <p className={cn('text-sm', 'ea-attribute-generic__no-attribute-text')}>{t('text445')}.</p>
      )}
    </div>
  );
}
